var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleEffect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 305,
    height: 305,
    viewBox: "0 0 305 305",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 152.039,
    cy: 152.035,
    r: 150.43,
    fill: "url(#paint0_linear_5318_9456)",
    fillOpacity: 0.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_5318_9456)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 152.039,
    cy: 152.035,
    r: 150.43,
    fill: "url(#paint1_linear_5318_9456)",
    fillOpacity: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_5318_9456",
    x: 0.00380611,
    y: -0.000100136,
    width: 304.071,
    height: 304.071,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.802784,
    result: "effect1_foregroundBlur_5318_9456"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5318_9456",
    x1: -302.746,
    y1: 226.221,
    x2: 366.3,
    y2: 25.6415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#673CD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5318_9456",
    x1: -302.746,
    y1: 226.221,
    x2: 366.3,
    y2: 25.6415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#673CD4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleEffect);
export default __webpack_public_path__ + "static/media/Circle Effect.edd4c09516d95bc6b5f2c885ca28ad7b.svg";
export { ForwardRef as ReactComponent };